module.exports = __webpack_public_path__ + "8b310db65bcdf7006155f3ed3f1e6527.svg";